import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LaborAutomaticTimer {
  id: string;
  isRunning: boolean;
  startedAt: string;
}

const initialState: LaborAutomaticTimer[] = [];

const reducers = {
  addLaborAutomaticTimer: (
    state: LaborAutomaticTimer[],
    action: PayloadAction<{ reminderId: string }>,
  ) => {
    const { reminderId } = action.payload;
    state.push({ id: reminderId, isRunning: false, startedAt: "" });
  },
  updateReminder: (state: LaborAutomaticTimer[], action: PayloadAction<{ reminderId: string }>) => {
    const { reminderId } = action.payload;
    const reminder = state.find((reminder: LaborAutomaticTimer) => reminder.id === reminderId);
    if (reminder) {
      reminder.isRunning = true;
      reminder.startedAt = new Date().toISOString();
    }
  },
};

export const laborAutomaticTimersSlice = createSlice({
  name: "laborAutomaticTimers",
  initialState,
  reducers,
});

export const { addLaborAutomaticTimer, updateReminder } = laborAutomaticTimersSlice.actions;

export default laborAutomaticTimersSlice.reducer;
